import React from "react";

function Skills() {
    return (
        <section className="skills">
            Skills
            <ul className="skills-points">
                <li>C++</li>
                <li>Python</li>
                <li>Rust</li>
                <li>Swift</li>
                <li>JavaScript</li>
                <li>SQL</li>
                <li>Bash</li>
                <li>ReactJS</li>
                <li>Qt</li>
                <li>QML</li>
                <li>Terraform</li>
                <li>AWS</li>
                <li>Docker</li>
                <li>Git</li>
                <li>Java</li>
            </ul>
        </section>
    );
}

export default Skills;
